export default __webpack_public_path__ + "static/media/Path -21@2x.a143830c.png";